import React, { Component, useEffect, useState } from "react"
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"

// datatable related plugins
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
    PaginationProvider, PaginationListStandalone,
    SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import { BsEye, BsFillFileEarmarkTextFill } from "react-icons/bs";

// import the redux
import { useSelector, useDispatch } from 'react-redux'

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import useHttp from '../../hook/use-http';

import Embed from 'react-embed';


import "./datatables.scss"
import { productsData } from "../../common/data";
import { toast } from "react-toastify";


const ChannelList = ({ history }) => {


    // get the data with redux dispatch
    const dispatch = useDispatch()
    const dataJson = useSelector(state => state.DataJsonConsume.data)

    // this variable will be used to control the settings of the table
    const page = 1;
    const sizePerPage = 10;
    // save the product after add and extra fields
    const [productData, setProductData] = useState([]);
    const [amountItemsIntoList, setItemsIntoList] = useState(0);

    // this function will be used to request the server to login the user
    const { loading, error, request } = useHttp();

    // this function will be used to redirect to the product detail page
    const onClickRegisterTable = (id) => {
        history.push(`/channel-detail/${id}`)
    }

    const openPdf = (url) => {
        let convertUrl = url.substring(28, url.length)
        let pdfWindow = window.open("");
        pdfWindow.document.write("<html<head><title>" + "acuerdo_comercial" + "</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");
        pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(url) + "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>");
    }

    // this function will be process the result of the method getListChannel
    const handleGetListChannelDataResponse = (products) => {

        if (products.status === 401) {
            // show a error message here

            if (products.errorCode === 12) {
                localStorage.removeItem('token')
                localStorage.removeItem('user')
                localStorage.removeItem('email')
                localStorage.removeItem('role')
                history.push('/login')
            }

            toast(products.message, { type: 'error', autoClose: 10000 });

        } else {

            const result = [];
            // add and extra field to products
            products.map((item, index) => {

                item.id = index + 1

                // set the document into data
                //item.acuerdo_comercial = item.documentos.acuerdoComercialDocumento
                //item.ruc_documento = item.documentos.rucDocumento

                item.acuerdo_comercial = 'Link'
                item.ruc_documento = 'Link'

                item.change =
                    <button
                        className="btn btn-info" onClick={() => onClickRegisterTable(item.ruc)}
                        style={{ margin: 'auto', display: 'flex', backgroundColor: "#3af23a" }}
                    >
                        <div className="icon-eyes" > <BsFillFileEarmarkTextFill />
                        </div>
                    </button>

                if (item.acuerdo_comercial.length > 20) {
                    //item.acuerdo_comercial = <a onClick={() => openPdf(item.documentos.acuerdoComercialDocumento)}>link</a>
                    item.acuerdo_comercial = item.acuerdo_comercial.substring(0, 20) + "..."
                }

                if (item.ruc_documento.length > 20) {
                    item.ruc_documento = item.ruc_documento.substring(0, 15) + "..."
                }

                // if the field observaciones is greater than 20 we need to set this variable 
                /*
                if (item.observaciones.length > 20) {
                    item.observaciones = item.observaciones.substring(0, 15) + "..."
                }
                */

                // set the status of the channel
                //item.estado = item.estado === true ? "ACTIVO" : "INACTIVO";

                result.push(item)
            });

            setItemsIntoList(result.length)
            setProductData(result);

        }
    }

    // this function will be used to request the data from the server
    const getListChannel = () => {

        try {

            // set the header of the request
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));

            request({
                url: '/auth/channel/list',
                method: 'GET',
                headers: myHeaders,
            }, handleGetListChannelDataResponse)

        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {

        getListChannel();

    }, [])


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            sort: true,
        },
        {
            dataField: 'razonSocial',
            text: 'RAZON SOCIAL',
            sort: true,
        }, {
            dataField: 'ruc',
            text: 'RUC',
            sort: true
        }, {
            dataField: 'direccionEmpresa',
            text: 'DIRECCION',
            sort: true
        }, {
            dataField: 'estado',
            text: 'ESTADO',
            sort: true
        },/* {
            dataField: 'acuerdo_comercial',
            text: 'ACUERDO COMERCIAL',
            sort: true
        }, {
            dataField: 'ruc_documento',
            text: 'RUC DOCUMENTO',
            sort: true
        }, */{
            dataField: 'observaciones',
            text: 'OBSERVACIONES',
            sort: true
        }, {
            dataField: 'change',
            text: 'DETALLES',
            sort: false
        }];

    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];

    const pageOptions = {
        sizePerPage: 10,
        totalSize: amountItemsIntoList, // replace later with size(customers),
        custom: true,
    }

    const { SearchBar } = Search;

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">

                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>

                                    <PaginationProvider
                                        pagination={paginationFactory(pageOptions)}
                                        keyField='id'
                                        columns={columns}
                                        data={productData}
                                    >
                                        {({ paginationProps, paginationTableProps }) => (
                                            <ToolkitProvider
                                                keyField='id'
                                                columns={columns}
                                                data={productData}
                                                search
                                            >
                                                {toolkitProps => (
                                                    <React.Fragment>

                                                        <Row className="mb-2">
                                                            <Col md="4">
                                                                <div className="search-box me-2 mb-2 d-inline-block">
                                                                    <div className="position-relative">
                                                                        <SearchBar
                                                                            {...toolkitProps.searchProps}
                                                                        />
                                                                        <i className="search-box chat-search-box" />
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>


                                                        <Row>
                                                            <Col xl="12">
                                                                <div className="table-responsive" >

                                                                    <BootstrapTable
                                                                        id="table-responsive"
                                                                        keyField={"id"}
                                                                        responsive
                                                                        bordered={false}
                                                                        striped={false}
                                                                        defaultSorted={defaultSorted}
                                                                        classes={
                                                                            "table align-middle table-nowrap"
                                                                        }
                                                                        headerWrapperClasses={"thead-light"}
                                                                        {...toolkitProps.baseProps}
                                                                        {...paginationTableProps}
                                                                    />

                                                                </div>
                                                            </Col>
                                                        </Row>



                                                        <Row className="align-items-md-center mt-30">
                                                            <Col className="inner-custom-pagination d-flex">
                                                                <div className="d-inline">
                                                                    <SizePerPageDropdownStandalone
                                                                        {...paginationProps}
                                                                    />
                                                                </div>
                                                                <div className="text-md-right ms-auto">
                                                                    <PaginationListStandalone
                                                                        {...paginationProps}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </React.Fragment>
                                                )
                                                }
                                            </ToolkitProvider>
                                        )
                                        }</PaginationProvider>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )

}

export default ChannelList